module.exports = __webpack_public_path__ + "img/sp.536b9277.jpg";